<template>
  <div class="recommendPage">
    <swiper :options="swiperOption" ref="mySwiper" class="swiper-wrapper">
      <!-- 幻灯内容 -->
      <swiper-slide class="swiper-slide" v-for="(item, i) in picList" :key="i">
        <img :src="item.src"
      /></swiper-slide>

      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!--分页器。如果放置在swiper-container外面，需要自定义样式。-->
  </div>
</template>
<script>
//1.导入组件
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  // name: "swiper",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ["opt"],
  data() {
    return {
      swiperOption: {
        //垂直方向滑动
        direction: "vertical",
        autoplay: true,
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1,
        mousewheel: true,
        mousewheelControl: true,
        speed: 700, // 切换速度
        // 高度设置，占满设备高度
        height: window.innerHeight,
        resistanceRatio: 0,
        observeParents: true,
        //分页器

        pagination: {
          el: ".swiper-pagination",

          clickable: true, // 允许点击小圆点跳转
          type: "bullets",
          bulletClass: "swiper-pagination-bullet",
        }, // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      picList: [
        {
          id: 0,
          src: "https://gtms01.alicdn.com/tps/i1/T1Ww_JFEpdXXcZd9sr-640-200.png",
          url: "www.baidu.com",
        },
        {
          id: 1,
          src: "https://gw.alicdn.com/imgextra/i3/149/O1CN01wekXPw1CyHZ23AC4R_!!149-0-lubanu.jpg",
          url: "www.acfun.cn",
        },
        {
          id: 1,
          src: "https://gw.alicdn.com/imgextra/i3/149/O1CN01wekXPw1CyHZ23AC4R_!!149-0-lubanu.jpg",
          url: "www.bilibili.com",
        },
        {
          id: 1,
          src: "https://gw.alicdn.com/imgextra/i3/149/O1CN01wekXPw1CyHZ23AC4R_!!149-0-lubanu.jpg",
          url: "www.baidu.com",
        },
      ],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    //点击跳到对应的index页面
    changeIndex(index) {
      console.log(index);
      window.open("https://" + index);
    },
  },
};
</script>
<style scoped>
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  height: 400px;
}
.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  line-height: 200px;
  /* border:1px solid green; */
  color: #000;
  font-size: 16px;
  text-align: center;
}
.swiper-pagination {
  position: inherit;
  text-align: center;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}
/* 穿透修改样式 */
.change ::v-deep  .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
}
</style>